module.exports = __webpack_public_path__ + "img/BIT_white24.a5bc4e7f.jpg";